import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { FunctionComponent } from 'react';

import {
  FolkloreType,
  MyTargetedUsersQuery,
} from '../../../../../apollo/__generated__/graphql';
import { folkloreNameByFolklore } from '../../../../../user/services/user.service';
import { useMyTargetedUsersQuery } from '../../../../hooks/useMyTargetedUsersQuery';

interface MyTargetedUsersTabProps {
  eventId: string;
}

const columns: GridColDef<MyTargetedUsersQuery['myTargetedUsers'][number]>[] = [
  {
    field: 'firstname',
    headerName: 'Nom',
    width: 150,
    renderCell: (params) =>
      `${params.row.firstname} ${params.row.lastname?.substring(0, 1)}.`,
  },
  {
    field: 'nickname',
    headerName: 'Surnom',
    width: 150,
  },
  {
    field: 'folklore',
    headerName: 'Folklore',
    renderCell: (params) =>
      folkloreNameByFolklore[params.row.folklore ?? FolkloreType.Other],
    width: 100,
  },
  {
    field: 'studyTown',
    headerName: 'Ville',
    width: 150,
  },
  {
    field: 'studies',
    headerName: 'Fillière',
    width: 150,
  },
];

export const MyTargetedUsersTab: FunctionComponent<MyTargetedUsersTabProps> = ({
  eventId,
}) => {
  const { data: userTargetsData, loading } = useMyTargetedUsersQuery(eventId);

  return (
    <DataGrid
      rows={userTargetsData?.myTargetedUsers ?? []}
      columns={columns}
      loading={loading}
    />
  );
};
